import { LockKeyhole, MessageSquare, Plus } from "lucide-react";
import { useState } from "react";
import { formatJsDateWithHour } from "../../utils/formatageDate";
import { AddCommentModal } from "../../components/reusableComponents/AddCommentModal";

const CandidateComment = ({ candidate, candidates, setCandidates }) => {
  const [comments, setComments] = useState(candidate.comments || []);
  const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);

  return (
    <div className="space-y-4 text-sm">
      {isAddCommentModalOpen && (
        <AddCommentModal
          isOpen={isAddCommentModalOpen}
          onClose={() => setIsAddCommentModalOpen(false)}
          candidates={candidates}
          setCandidates={setCandidates}
          candidate={candidate}
          setComments={setComments}
          comments={comments}
        />
      )}
      <div className="flex flex-wrap justify-between items-center gap-3 mb-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Commentaire</h2>
          <div className="mt-2 flex items-center gap-2 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1 rounded-md bg-slate-100 px-2 py-1">
              <LockKeyhole size={12} />
              Interne
            </span>
            <span>
              {comments.length} commentaire{comments.length > 1 ? "s" : ""}
            </span>
          </div>
        </div>
        <button
          className="inline-flex items-center rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800"
          onClick={() => setIsAddCommentModalOpen(true)}
        >
          <Plus size={16} className="mr-2" />
          Ajouter un commentaire
        </button>
      </div>

      {comments.length ? (
        <div className="space-y-3">
          {[...comments]
            .sort(
              (a, b) =>
                (new Date(b.createdAt).getTime() || 0) -
                (new Date(a.createdAt).getTime() || 0),
            )
            .map((comment, index) => (
              <article
                key={comment._id || index}
                className="flex gap-3 rounded-xl border border-slate-200 bg-white p-4 transition-colors hover:border-blue-200 sm:gap-4"
              >
                <span
                  aria-hidden="true"
                  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-50 text-xs font-semibold text-blue-700"
                >
                  {(comment.commentator || "Recruteur")
                    .trim()
                    .split(/\s+/)
                    .map((part) => part[0])
                    .slice(0, 2)
                    .join("")
                    .toUpperCase()}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="mb-2 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                    <span className="text-sm font-semibold text-slate-900">
                      {comment.commentator || "Recruteur"}
                    </span>
                    <time className="text-xs text-slate-400">
                      {comment.createdAt
                        ? formatJsDateWithHour(comment.createdAt)
                        : ""}
                    </time>
                  </div>
                  <p className="whitespace-pre-wrap break-words text-sm leading-6 text-slate-600">
                    {comment.comment}
                  </p>
                </div>
              </article>
            ))}
        </div>
      ) : (
        <div className="flex flex-col items-center rounded-xl bg-slate-50 px-6 py-10 text-center">
          <span className="mb-3 rounded-xl bg-white p-3 text-blue-600 shadow-sm">
            <MessageSquare size={24} />
          </span>
          <p className="text-sm font-semibold text-slate-800">
            Aucun commentaire pour le moment
          </p>
          <p className="mt-1 text-xs text-slate-500">
            Gardez ici les informations utiles à votre équipe.
          </p>
          <button
            type="button"
            onClick={() => setIsAddCommentModalOpen(true)}
            className="mt-4 text-sm font-semibold text-blue-700 hover:text-blue-800"
          >
            Ajouter le premier commentaire
          </button>
        </div>
      )}
    </div>
  );
};

export default CandidateComment;
